// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"925e86ad","501":"4508deda","507":"c6aa4f22","726":"2efc1f8a"}[chunkId] + ".chunk.js";
};